export const entityTypes = {
  PRODUCT: 'product',
  PATTERN: 'pattern',
  ARTICLE: 'article'
};

export const LOW_STOCK_THRESHOLD = 10;
export const REVIEWS_PER_PAGE = 10;
